<template>
  <div id="app">
    <el-container class="app-container">
      <el-header>
        <div class="app-header common-layout">
          <!-- ★修改：在 manshonRegist / inquary 时，logo 不可点击 -->
          <router-link
            v-if="isLogoClickable"
            class="app-header-logo"
            to="/"
            @click.native.prevent="goLoginWithManshonId"
          ></router-link>

          <div
            v-else
            class="app-header-logo logo-disabled"
            aria-disabled="true"
          ></div>

          <div class="app-header-title">{{ manshonName ? `${manshonName}` : '' }}</div>

          <div v-if="!isLoginPage && !isForgot && !isResetPassword && (isBoard && isLogin)" class="app-header-right">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="el-dropdown-link">
                <el-avatar size="small" style="margin-right: 10px"
                  :src="myPageLogo"
                ></el-avatar>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item command="goSetpassword">パスワード変更</el-dropdown-item>
                <el-dropdown-item command="logout">ログアウト</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <span>{{userNameKanji}}</span>
          </div>
        </div>
      </el-header>
      <el-main>
        <div class="app-main common-layout">
          <router-view v-if="isRouterAlive"></router-view>
        </div>
      </el-main>
      <el-footer height="auto"  v-if="!isHtmlPage">
        <PCFooter />
        <PhoneFooter />
      </el-footer>
      <el-backtop></el-backtop>
    </el-container>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import request from '@/utils/request';
// import footerLogo from './assets/footer_logo.png';
// import footerLogo from './assets/logo.gif';
import myPageLogo from './assets/user.png';
import PCFooter from './components/PCFooter.vue';
import PhoneFooter from './components/PhoneFooter.vue';

export default {
  name: 'App',
  components: {
    PCFooter,
    PhoneFooter,
  },
  provide() {
    return {
      reload: this.reload,
      isLoginPage: this.isLoginPage,
      isResetPassword: this.isResetPassword,
      isForgot: this.isForgot,
      isBoard: this.isBoard,
      isHtmlPage: this.isHtmlPage,
      manshonId: () => this.manshonId,
      toList: () => this.toList
    };
  },
  data() {
    return {
      manshonId: null,
      manshonName: '',
      toList: [],
      myPageLogo,
      // footerLogo,
      isRouterAlive: true,
      activeIndex: '1',
      isLoginPage: false,
      isForgot: false,
      isBoard: false,
      isResetPassword: false,
      isMyPage: false,
      isHtmlPage: false,
      messageNum: 0,
      footerList: [
        [
          {
            title: '重要事項',
            items: [
              {
                title: '個人情報保護方針',
                // to: '/privacy.html',
              },
              {
                title: '利用規約',
                // to: '/terms.html',
              },
            ],
          },
        ],
        [
          {
            title: '重要事項',
            items: [
              {
                // title: '免責事項',
                // to: '/disclaimer.html',
              },
              {
                // title: '推奨ブラウザ',
                // to: '/recommendedBrowser.html',
              },
            ],
          },
        ],
        [
          {
            title: '重要事項',
            items: [
              {
                title: 'ご利用ガイド',
                // to: '/guide/guide.html',
              },
              {
                title: 'よくあるご質問',
                // to: '/guide/faq.html',
              },
            ],
          },
        ],
        [
          {
            title: '受講受験ナビ',
            items: [
              {
                title: '運営会社',
                // to: 'https://www.tkhs.co.jp/company/outline.html',
              },
            ],
          },
        ],
        [],
        [],
      ],
      userNameKanji: '',
    };
  },
  created() {
    const hrefLower = (window.location.href || '').toLowerCase();
    if (hrefLower.indexOf('manshonregist') !== -1 || hrefLower.indexOf('inquary') !== -1) {
      return;
    }

    // URL に homePage が含まれている場合、末尾に .html を付けて遷移
    if (window.location.href.indexOf('homePage') !== -1) {
      const url = window.location.href;
      if (!/\.html(\?|#|$)/.test(url)) {
      window.location.replace(url + '.html');
      }
      return;
    }

    // URLからmanshonIdを取得（例: ?manshonId=1001）
    const urlManshonId = new URLSearchParams(window.location.search).get('manshonId');

    if (urlManshonId) {
      // URLにmanshonIdが含まれている場合：その値を使う
      this.manshonId = urlManshonId;
      // ついでにlocalStorageに保存（次回以降のアクセスでも使えるように）
      localStorage.setItem('sessionManshonId', urlManshonId);
    } else {
      const stored = localStorage.getItem('sessionManshonId');
      if (stored) {
        // URLにmanshonIdが無い場合：localStorageから取得してみる
        this.manshonId = stored;
      } else {
        // どこにもmanshonIdが無い場合：アラートを表示する
        alert('マンションIDが見つかりません。ホームページからアクセスしてください。');
      }
    }

    this.getToInfo();
  },
  watch: {
    $route(to) {
      this.isMyPage = /^\/mypage/.test(to.path);
      this.isLoginPage = to.name === 'Login';
      this.isForgot = to.name === 'Forgot';
      this.isBoard = to.name === 'Board';
      this.isResetPassword = to.name === 'Resetpassword';
      this.isHtmlPage = /^\/showHtml/.test(to.path);

      // ★ 修正2：从 Login 等页面跳转到 ManshonRegist 或 Inquary 时，将残留的 manshonName 清空
      const pathLower = (to.path || '').toLowerCase();
      if (pathLower.indexOf('manshonregist') !== -1 || pathLower.indexOf('inquary') !== -1) {
        this.manshonName = '';
      }

      if (Cookies.get('userNameKanji') !== null && Cookies.get('userNameKanji') !== '') {
        this.userNameKanji = Cookies.get('userNameKanji');
      }
    },
  },
  computed: {
    // クッキーのトークンの有無でログイン状態を確認
    isLogin() {
      return !!Cookies.get('token');
    },


    // ★ 修正3：logo不可点击判断也改为转小写比较
    isLogoClickable() {
      const hrefLower = (window.location.href || '').toLowerCase();
      return !(hrefLower.indexOf('manshonregist') !== -1 || hrefLower.indexOf('inquary') !== -1);
    },

    badgeRight() {
      if (this.messageNum === 0) {
        return '0';
      }
      if (this.messageNum < 10) {
        return '10px';
      }
      return '20px';
    },
  },
  methods: {
    getToInfo() {
      // this.manshonName = sessionStorage.getItem('sessionManshonName');
      // this.toList = JSON.parse(sessionStorage.getItem('sessionTblToInfoList'))
      // if (this.toList) {
      //   return;
      // }
      request('toInfo', {
        manshonId: this.manshonId,
      }).then((res) => {
        this.manshonName = res.manshonName;
        this.toList = res.tblToInfoList;
        sessionStorage.setItem('sessionManshonName', this.manshonName);
        sessionStorage.setItem('sessionTblToInfoList', JSON.stringify(this.toList));
      });
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    },
    goPage(path) {
      this.$router.push({
        path,
      }).catch(() => {});
    },
    goSetpassword() {
      this.goPage('/setpassword');
    },
    handleCommand(command) {
      this[command]();
    },
    logout() {
      request('logout').finally(() => {
        Cookies.remove('token');
        this.$router.push({
          path: '/login',
          query: { manshonId: this.manshonId },
        }).catch(() => {});
      });
    },
    goLoginWithManshonId() {
      if (window.location.href.indexOf('manshonRegist') !== -1
        || window.location.href.indexOf('inquary') !== -1) {
        return;
      }
      const manshonId = localStorage.getItem('sessionManshonId');
      this.$router.push({ path: '/board', query: { manshonId } });
    },
  },
};
</script>

<style lang="less" scoped>
#app {
  height: 100%;
  .app-container {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    position: relative;
    overflow: hidden;

    .el-header {
      position: fixed;
      z-index: 10000;
      width: 100%;
      padding: 0;
      background: #d4ecf4;

      .app-header {
        position: relative;
        color: #0f3264;

        .app-header-logo {
          width: 300px;
          height: 100%;
          float: left;
          position: relative;
          background: url(assets/wan-nyan-mate_logo_yoko.png) no-repeat;
          background-size: contain;
          background-position: center;
        }

        /* ★追加：非クリック状態の見た目（必要なら調整） */
        .logo-disabled {
          cursor: default;
          pointer-events: none;
          opacity: 0.9;
        }

        .app-header-title {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%, -50%);
          font-size: 20px;
        }

        .app-header-right {
          float: right;
          height: 100%;
          display: flex;
          align-items: center;

          .app-header-badge {
            font-size: 20px;
          }
          & > div {
            padding: 0 10px;
            cursor: pointer;
            position: relative;
            transition: color .3s;
            font-size: 14px;

            &:hover {
              color: #ccc;
            }

            &:after {
              display: block;
              content: "";
              position: absolute;
              top: 0;
              right: 0;
              height: 100%;
              width: 1px;
              // background-color: #94CE58;
              background-color: #ddd;
            }

            &:first-child {
              padding-left: 0;
            }
            &:last-child {
              padding-right: 0;

              &:after {
                display: none;
              }
            }

            span {
              font-size: 14px;
              vertical-align: middle;
            }
            .app-header-bell {
              margin-right: 10px;
              font-size: 20px;
              vertical-align: middle;
            }
          }
        }
      }
    }
    .el-main {
      flex: 1 0 auto;
      display: flex;
      flex-direction: column;
      width: 100%;
      overflow: auto;
      margin-top: 60px;
      padding: 0;

      .app-main {
        flex: 1;
        // margin: 0 auto;
        // max-width: 1400px;
        // padding: 0 24px;
      }
    }
    .el-footer {
      background: #d4ecf4;
    }
  }
}
@media (max-width: 767px) {
  #app {
    .app-container {
      .el-header {
        height: 40px!important;
        .app-header {
          padding: 0 5px;
          .app-header-logo {
            width: 120px;
          }
          .app-header-title {
            font-size: 14px;
          }
        }
      }
      .el-main {
        margin-top: 40px;
      }
      .el-backtop {
        display: none;
        background-color: #ccc;
      }
    }
  }
}
</style>
